export const url = process.env.REACT_APP_URL;

export const Constants = {
    url,
    baseUrl: url.concat("/api/admin"),
};

// Arte da marca.
//
// Os caminhos vêm codificados porque os nomes dos arquivos têm espaço: `/images/PRL LOGO BGW.png`
// literal não é uma URL válida e o servidor recusa — só `%20` funciona.
//
// Os dois arquivos são quadrados (500x500) com a arte centralizada e o resto transparente. Onde o
// espaço vertical é apertado (barra da marca na sidebar, header mobile), a margem transparente é
// recortada por CSS — ver `.kt-aside__brand-logo` em `src/styles/_layout.scss`.
export const Brand = {
    logo: "/images/PRL%20LOGO%20BGW.png",
    icon: "/images/PRL%20ICONE%20BGW.png",
};
